import React from "react";
import {Nav} from "react-bootstrap";

const PrintButton = ({contentRef}) => {
    // const handlePrint = useReactToPrint({contentRef});
   function handlePrint() {
       window.print()
   }

    return (
        <Nav.Item className={"print-hide"}>
            <Nav.Link onClick={handlePrint} active> <i className="fas fa-print"></i>
            </Nav.Link>
        </Nav.Item>

    );
};

export default PrintButton;
